
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire34b5"];
var parcelRegister = parcelRequire.register;
parcelRegister("loGjz", function(module, exports) {
$parcel$export(module.exports, "LanguageSelector", function () { return (parcelRequire("8qYD3")).LanguageSelector; });

var $8qYD3 = parcelRequire("8qYD3");

});
parcelRegister("8qYD3", function(module, exports) {
$parcel$export(module.exports, "LanguageSelector", function () { return $777f9e84e8aa39b3$export$ddd501dda1f62236; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $gieZF = parcelRequire("gieZF");
const $777f9e84e8aa39b3$export$ddd501dda1f62236 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler, className: className, testId: testId })=>{
    const intl = (0, $8e22h.default)();
    if (!selectedLanguage) selectedLanguage = intl.locale || "en";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-v2-language-selector",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gieZF.default), {
            selectedLanguage: selectedLanguage,
            onLanguageChangeHandler: onLanguageChangeHandler,
            className: className,
            testId: testId
        })
    });
};

});
parcelRegister("gieZF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $16a7d960140cfe88$export$2e2bcd8739ae039; });
/* language-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $5r4Ts = parcelRequire("5r4Ts");
var $kKAAc = parcelRequire("kKAAc");

var $g1rTV = parcelRequire("g1rTV");

var $FapDU = parcelRequire("FapDU");

var $hu7gH = parcelRequire("hu7gH");

var $aKcYL = parcelRequire("aKcYL");
/**
 * Custom React-Select's Control component to allow adding the globe icon.
 */ const $16a7d960140cfe88$var$Control = (_param)=>{
    var { children: children } = _param, props = (0, $aPnCa._)(_param, [
        "children"
    ]);
    // @ts-ignore
    const { isMouseOver: isMouseOver } = props.selectProps;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5r4Ts.c).Control, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKcYL.LanguageGlobeIcon), {
                color: isMouseOver ? "#172b4d" : "#42526e"
            }),
            children
        ]
    }));
};
/**
 * Custom React-Select's DropdownIndicator component to update the arrow icon.
 */ const $16a7d960140cfe88$var$DropdownIndicator = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5r4Ts.c).DropdownIndicator, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        children: "\u25BE"
    }));
};
/**
 * Styles for the LanguageSelector container div.
 */ const $16a7d960140cfe88$var$languageSelectorContainerStyle = null;
/**
 * Global footer's language selector component.
 * Uses React-Select to render the language selector with custom styling and on mouseover behavior.
 * Dropdown menu and the options have the same styling as WPL DropdownSelector.
 *
 * @param selectedLanguage - The selected language. Defaults to 'en'.
 * @param onChangeHandler - The function to call when a different language is selected.
 * @param className - The class name to apply to the container div.
 */ const $16a7d960140cfe88$var$LanguageSelector = ({ selectedLanguage: selectedLanguage = "en", onLanguageChangeHandler: onLanguageChangeHandler, className: className, testId: testId })=>{
    const intl = (0, $8e22h.default)();
    const [isMouseOver, setMouseOver] = (0, $1oC0p.useState)(false);
    const elementID = "language-dropdown";
    if (!onLanguageChangeHandler) onLanguageChangeHandler = (newLocale)=>{
        // check if there is already a locale in the path
        const { path: path } = (0, $hu7gH.parseRoute)(window.location);
        // exclude trailing slash in the case of the home page
        window.location.href = path.length ? `/${newLocale}/${path}` : `/${newLocale}`;
    };
    const languageSelectStyle = {
        container: (provided)=>(0, $dPABA._)((0, $6ogO3._)({}, provided), {
                appearance: "none",
                flexDirection: "row",
                fontSize: "0.875rem;",
                textAlign: "left"
            }),
        control: (provided, state)=>(0, $dPABA._)((0, $6ogO3._)({}, provided), {
                color: isMouseOver ? "#172b4d" : "#42526e",
                cursor: isMouseOver ? "pointer" : "default",
                display: "inline-flex",
                border: state.isFocused ? `2px solid #4c9aff` : "2px solid transparent"
            }),
        valueContainer: (provided)=>(0, $dPABA._)((0, $6ogO3._)({}, provided), {
                marginLeft: "var(--ds-space-050, 4px)",
                textDecorationLine: isMouseOver ? "underline" : "none"
            }),
        indicatorsContainer: (provided)=>(0, $dPABA._)((0, $6ogO3._)({}, provided), {
                marginLeft: "var(--ds-space-050, 4px)"
            }),
        dropdownIndicator: (provided)=>(0, $dPABA._)((0, $6ogO3._)({}, provided), {
                fontSize: "1.5rem",
                height: "40px"
            }),
        menu: (provided)=>(0, $dPABA._)((0, $6ogO3._)({}, provided), {
                marginTop: "var(--ds-space-050, 4px)",
                boxShadow: "0px 3px 5px 0px #091E4233",
                background: "#ffffff",
                borderRadius: "var(--ds-space-050, 4px)",
                width: "5.5rem"
            }),
        option: (provided, state)=>(0, $dPABA._)((0, $6ogO3._)({}, provided), {
                "cursor": "pointer",
                "padding": `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
                "backgroundColor": state.isSelected ? "#b2d4ff" : state.isFocused ? "#ebecf0" : "#fafbfc",
                "color": state.isSelected ? "#0065ff" : "#172b4d",
                "&:hover": {
                    background: state.isSelected ? "#b2d4ff" : "#ebecf0"
                },
                "&:active": {
                    background: "#dfe1e5"
                }
            })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                    htmlFor: elementID,
                    children: intl.formatMessage({
                        defaultMessage: "Language selector",
                        id: "globalFooter.bottom.language-selector.label"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c116y",
                    className
                ]),
                "data-testid": testId,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
                    name: "global-footer-v2-language-selector-component",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kKAAc.default), {
                        inputId: elementID,
                        defaultValue: (0, $aKcYL.languages).find((language)=>language.value === selectedLanguage),
                        options: (0, $aKcYL.languages),
                        onChange: (selectedOption)=>{
                            selectedOption && selectedOption.value !== selectedLanguage && (onLanguageChangeHandler === null || onLanguageChangeHandler === void 0 ? void 0 : onLanguageChangeHandler(selectedOption.value));
                        },
                        unstyled: true,
                        // @ts-ignore
                        isMouseOver: isMouseOver,
                        onMenuClose: ()=>setMouseOver(false),
                        "aria-label": intl.formatMessage({
                            defaultMessage: "Choose your language",
                            id: "globalFooter.bottom.language-selector"
                        }),
                        components: {
                            Control: $16a7d960140cfe88$var$Control,
                            DropdownIndicator: $16a7d960140cfe88$var$DropdownIndicator
                        },
                        styles: languageSelectStyle,
                        menuPlacement: "auto"
                    })
                })
            })
        ]
    });
};
var $16a7d960140cfe88$export$2e2bcd8739ae039 = $16a7d960140cfe88$var$LanguageSelector;

});




//# sourceMappingURL=language-selector.fd1724c4.js.map
